import React from 'react';
import { ModalProps } from '../../types/modal-types';
import { useModal } from '../../hooks/useModal';

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'medium',
  closeOnOverlayClick = true,
  showCloseButton = true,
  overlayStyle = {},
  modalStyle = {},
  headerStyle = {},
  bodyStyle = {},
  footerStyle = {},
  className = ''
}) => {
  const {
    defaultOverlayStyle,
    defaultModalStyle,
    defaultHeaderStyle,
    defaultBodyStyle,
    defaultFooterStyle
  } = useModal({
    size,
    overlayStyle,
    modalStyle,
    headerStyle,
    bodyStyle,
    footerStyle
  });

  if (!isOpen) return null;

  return (
    <div
      style={defaultOverlayStyle}
      onClick={closeOnOverlayClick ? onClose : undefined}
    >
      <div
        style={defaultModalStyle}
        className={className}
        onClick={(e) => e.stopPropagation()}
      >
        {(title || showCloseButton) && (
          <div style={defaultHeaderStyle}>
            <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#1f2937' }}>
              {title}
            </h2>
            {showCloseButton && (
              <button
                onClick={onClose}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#6b7280',
                  padding: '0',
                  lineHeight: '1'
                }}
              >
                ×
              </button>
            )}
          </div>
        )}
        <div style={defaultBodyStyle}>{children}</div>
        {footer && <div style={defaultFooterStyle}>{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;

